(function () {
  'use strict';

  if (window.B2BPriceCalculatorInstance) {
    console.log('B2B Pricing: Bereits initialisiert, überspringe...');
    return;
  }

  class B2BPriceCalculator {
    constructor() {
      this.customerData = null;
      this.taxRates = null;
      this.wrapper = null;
      this.intersectionObserver = null;
      this.mutationDebounceTimer = null;
      this.variantDebounceTimer = null;
      this.priceCache = new Map();
      this.productIsReduced = false; // Store product-level reduced tax setting
      this.init();
    }

    init() {
      this.wrapper = document.querySelector('.b2b-price-wrapper');
      if (!this.wrapper) {
        console.log('B2B Pricing: Wrapper-Element nicht gefunden');
        return;
      }

      // Debug: Log raw data-price value immediately
      const priceEl = document.querySelector('[data-product-id][data-price]');
      if (priceEl) {
        console.log('B2B Pricing: RAW data-price on init:', priceEl.dataset.price, 'data-is-reduced:', priceEl.dataset.isReduced);
      }

      this.loadCustomerDataFromDOM();

      if (!this.customerData?.isB2B || !this.customerData?.isTaxExempt) {
        console.log('B2B Pricing: Customer ist nicht steuerbefreit');
        return;
      }

      // if (this.customerData.country === 'AT') {
      //   console.log('B2B Pricing: Österreich ist nicht steuerbefreit');
      //   return;
      // }

      // if (this.customerData.country === 'AT' && !this.customerData.isTaxExempt) {
      //   console.log('B2B Pricing: Österreich ist nicht steuerbefreit');
      //   return;
      // }

      console.log('B2B Pricing: Initialisiere Preisberechnung...');
      this.loadTaxRatesFromDOM();
      console.log('B2B Pricing: Tax Rates:', this.taxRates);

      this.loadCachedPrices();

      this.calculateProductPrice();
      this.setupIntersectionObserver();
      this.observeVariantChanges();
      this.observeDOMChanges();
    }

    // loadCustomerDataFromDOM() {
    //   const isB2B = this.wrapper.dataset.isB2b === 'true';
    //   const isTaxExempt = this.wrapper.dataset.isTaxExempt === 'true';
    //   const country = this.wrapper.dataset.customerCountry || 'AT';

    //   this.customerData = {
    //     isB2B,
    //     isTaxExempt,
    //     country
    //   };

    //   console.log('B2B Pricing: Customer Data (from Liquid):', this.customerData);
    // }

    loadCustomerDataFromDOM() {
      const isB2B = this.wrapper.dataset.isB2b === 'true';
      const isTaxExempt = this.wrapper.dataset.isTaxExempt === 'true';

      // Try DOM attribute first, then Shopify.country, then final fallback AT
      let country =
        this.wrapper.dataset.customerCountry ||
        (window.Shopify && Shopify.country
          ? Shopify.country.split('-').pop() // "de-DE" -> "DE"
          : 'AT');

      this.customerData = {
        isB2B,
        isTaxExempt,
        country
      };

      console.log('B2B Pricing: Customer Data (from Liquid):', this.customerData);
    }


    loadTaxRatesFromDOM() {
      try {
        if (this.wrapper.dataset.taxRates) {
          this.taxRates = this.parseTaxRates(this.wrapper.dataset.taxRates);
        } else {
          console.warn('B2B Pricing: Keine Steuersätze gefunden. Setze Shop Metafield "alpenpwr.steuersaetze"');
          this.taxRates = [];
        }
      } catch (error) {
        console.error('B2B Pricing: Fehler beim Laden der Steuersätze', error);
        this.taxRates = [];
      }
    }

    loadCachedPrices() {
      try {
        const cacheKey = this.getCacheKey();
        const cached = sessionStorage.getItem(cacheKey);

        if (cached) {
          const data = JSON.parse(cached);
          const cacheAge = Date.now() - data.timestamp;
          if (cacheAge < 30 * 60 * 1000) {
            console.log('B2B Pricing: Lade Preise aus Cache');
            this.priceCache = new Map(data.prices);
            return true;
          }
        }
      } catch (error) {
        console.warn('B2B Pricing: Fehler beim Laden des Caches', error);
      }
      return false;
    }

    saveCachedPrices() {
      try {
        const cacheKey = this.getCacheKey();
        const data = {
          timestamp: Date.now(),
          prices: Array.from(this.priceCache.entries())
        };
        sessionStorage.setItem(cacheKey, JSON.stringify(data));
      } catch (error) {
        console.warn('B2B Pricing: Fehler beim Speichern des Caches', error);
      }
    }

    getCacheKey() {
      const taxRate = this.getTaxRate(this.customerData.country, false);
      return `b2b_prices_${this.customerData.country}_${taxRate}`;
    }

    getCachedPrice(grossPriceCents, isReduced = false) {
      // Temporarily disable caching for debugging
      console.log('B2B Pricing: getCachedPrice called with grossPriceCents:', grossPriceCents, 'isReduced:', isReduced);
      const b2bPrice = this.calculateB2BPrice(grossPriceCents, isReduced);
      console.log('B2B Pricing: Calculated B2B price:', b2bPrice);
      return b2bPrice;

      // const cacheKey = `${grossPriceCents}_${isReduced}`;

      // if (this.priceCache.has(cacheKey)) {
      //   return this.priceCache.get(cacheKey);
      // }

      // const b2bPrice = this.calculateB2BPrice(grossPriceCents, isReduced);
      // this.priceCache.set(cacheKey, b2bPrice);
      // this.saveCachedPrices();

      // return b2bPrice;
    }

    parseTaxRates(taxRatesJson) {
      try {
        const rates = JSON.parse(taxRatesJson);
        return rates;
      } catch (e) {
        console.error('B2B Pricing: Fehler beim Parsen der Steuersätze', e);
        return [];
      }
    }

    getTaxRate(countryCode, isReduced = false) {
      if (!this.taxRates || this.taxRates.length === 0) {
        console.warn('B2B Pricing: Keine Steuersätze verfügbar');
        return null;
      }

      const country = this.taxRates.find(r => r.country === countryCode);
      if (!country) {
        console.warn(`B2B Pricing: Kein Steuersatz für Land ${countryCode} gefunden`);
        return null;
      }

      return isReduced ? country['reduced-rate'] : country['standard-rate'];
    }

    calculateNetPrice(grossPrice, taxRatePercent) {
      const taxRate = taxRatePercent / 100.0;
      const netPrice = grossPrice / (1.0 + taxRate);
      return this.shopifyRound(netPrice);
    }

    shopifyRound(value) {
      const multiplied = value * 100.0;
      const fractional = multiplied - Math.floor(multiplied);

      let rounded;
      if (fractional < 0.5) {
        rounded = Math.floor(multiplied);
      } else if (fractional > 0.5) {
        rounded = Math.ceil(multiplied);
      } else {
        const floor = Math.floor(multiplied);
        if (floor % 2 === 0) {
          rounded = floor;
        } else {
          rounded = Math.ceil(multiplied);
        }
      }

      return rounded / 100.0;
    }

    formatPrice(cents) {
      const formatter = new Intl.NumberFormat('de-AT', {
        style: 'currency',
        currency: 'EUR'
      });
      return formatter.format(cents / 100);
    }

    calculateB2BPrice(grossPriceCents, isReduced = false) {
      const grossPrice = grossPriceCents / 100;
      const taxRate = this.getTaxRate(this.customerData.country, isReduced);
      if (taxRate === null) {
        console.warn(`B2B Pricing: Kein Steuersatz für Land ${this.customerData.country} gefunden`);
        return grossPriceCents;
      }

      const netPrice = this.calculateNetPrice(grossPrice, taxRate);
      return Math.round(netPrice * 100);
    }

    calculateProductPrice() {
      console.log('B2B Pricing: calculateProductPrice() aufgerufen');
      const productPriceElements = document.querySelectorAll('[data-product-id]');
      console.log('B2B Pricing: Gefundene Produkt-Elemente:', productPriceElements.length);

      productPriceElements.forEach(productPriceElement => {
        if (!productPriceElement) return;

        const price = parseInt(productPriceElement.dataset.price);
        const comparePrice = parseInt(productPriceElement.dataset.comparePrice);
        console.log('B2B Pricing: Reading from DOM - price:', price, 'isReduced:', productPriceElement.dataset.isReduced);

        // Use stored product-level isReduced, or read from DOM and store it
        // This ensures the product metafield value is preserved across variant changes
        if (productPriceElement.dataset.isReduced !== undefined && productPriceElement.dataset.isReduced !== '') {
          this.productIsReduced = productPriceElement.dataset.isReduced === 'true';
        }
        const isReduced = this.productIsReduced;

        const b2bPrice = this.getCachedPrice(price, isReduced);

        const priceTarget = productPriceElement.querySelector('[data-price-target]');
        if (priceTarget) {
          priceTarget.innerHTML = this.formatPrice(b2bPrice);
          priceTarget.classList.add('b2b-price-active');
        }

        if (comparePrice && comparePrice > price) {
          const b2bComparePrice = this.getCachedPrice(comparePrice, isReduced);
          const comparePriceTarget = productPriceElement.querySelector('[data-compare-price-target]');
          if (comparePriceTarget) {
            comparePriceTarget.innerHTML = `<s>${this.formatPrice(b2bComparePrice)}</s>`;
          }
        }
      });

      this.hideOriginalPrices();
    }

    setupIntersectionObserver() {
      const productCards = document.querySelectorAll('.xo-product-card, .product-card, .product-item, [data-product-item]');

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.dataset.b2bPriceCalculated) {
            this.calculatePriceForCard(entry.target);
            entry.target.dataset.b2bPriceCalculated = 'true';
          }
        });
      }, {
        root: null,
        rootMargin: '50px',
        threshold: 0.01
      });

      productCards.forEach(card => {
        this.intersectionObserver.observe(card);
      });

      console.log(`B2B Pricing: Intersection Observer setup für ${productCards.length} Produkte`);
    }

    calculatePriceForCard(card) {
      // Try to find the robust B2B price element first
      {
        const b2bPriceElement = card.querySelector('[data-product-id][data-price]');
        if (b2bPriceElement) {
          const price = parseInt(b2bPriceElement.dataset.price);
          const comparePrice = parseInt(b2bPriceElement.dataset.comparePrice);
          const isReduced = b2bPriceElement.dataset.isReduced === 'true';

          const b2bPrice = this.getCachedPrice(price, isReduced);

          const priceTarget = b2bPriceElement.querySelector('[data-price-target]');
          if (priceTarget) {
            priceTarget.innerHTML = this.formatPrice(b2bPrice);
            priceTarget.classList.add('b2b-price-active');
          }

          if (comparePrice && comparePrice > price) {
            const b2bComparePrice = this.getCachedPrice(comparePrice, isReduced);
            const comparePriceTarget = b2bPriceElement.querySelector('[data-compare-price-target]');
            if (comparePriceTarget) {
              comparePriceTarget.innerHTML = `<s>${this.formatPrice(b2bComparePrice)}</s>`;
            }
          }
          return;
        }
      }

      // Fallback for other cards (legacy logic)
      const priceElement = card.querySelector('.price, [data-price]');
      if (!priceElement) return;

      b2bPriceElement.textContent = this.formatPrice(b2bPrice);

      priceElement.style.display = 'none';
      priceElement.parentNode.insertBefore(b2bPriceElement, priceElement);
    }

    calculateCollectionPrices() {
      const productCards = document.querySelectorAll('.xo-product-card:not([data-b2b-price-calculated]), .product-card:not([data-b2b-price-calculated]), .product-item:not([data-b2b-price-calculated]), [data-product-item]:not([data-b2b-price-calculated])');

      productCards.forEach(card => {
        if (this.intersectionObserver) {
          this.intersectionObserver.observe(card);
        } else {
          this.calculatePriceForCard(card);
          card.dataset.b2bPriceCalculated = 'true';
        }
      });
    }

    parsePriceFromText(text) {
      const cleaned = text.replace(/[^\d,]/g, '').replace(',', '.');
      return Math.round(parseFloat(cleaned) * 100);
    }

    hideOriginalPrices() {
      const selectors = [
        '.price:not(.b2b-price):not([data-price-target])',
        '.product-price__price:not(.b2b-price)',
        '[data-product-price]:not(.b2b-price)',
        '.price-item:not(.b2b-price)'
      ];

      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          if (el.parentNode.querySelector('.b2b-price, [data-price-target]')) {
            el.style.display = 'none';
          }
        });
      });
    }

    observeVariantChanges() {
      document.addEventListener('variant:change', (e) => {
        console.log('B2B Pricing: variant:change event received', e.detail);
        if (e.detail && e.detail.variant) {
          this.updatePriceForVariant(e.detail.variant);
        }
      });

      const variantSelects = document.querySelectorAll('select[name="id"], .product-form__input input[type="radio"]');
      console.log('B2B Pricing: Found variant selects:', variantSelects.length);
      variantSelects.forEach(select => {
        select.addEventListener('change', () => {
          console.log('B2B Pricing: Variant select changed');
          clearTimeout(this.variantDebounceTimer);
          this.variantDebounceTimer = setTimeout(() => {
            this.calculateProductPrice();
          }, 100);
        });
      });
    }

    updatePriceForVariant(variant) {
      console.log('B2B Pricing: variant received:', variant);
      const productPriceElement = this.wrapper.querySelector('[data-product-id]');
      if (!productPriceElement) return;

      productPriceElement.dataset.variantId = variant.id;
      productPriceElement.dataset.price = variant.price;
      productPriceElement.dataset.comparePrice = variant.compare_at_price || '';

      this.calculateProductPrice();
    }

    observeDOMChanges() {
      const observer = new MutationObserver((mutations) => {
        const hasRelevantChanges = mutations.some(mutation => {
          return Array.from(mutation.addedNodes).some(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              return node.matches && (
                node.matches('.xo-product-card, .product-card, .product-item, [data-product-item]') ||
                node.querySelector('.xo-product-card, .product-card, .product-item, [data-product-item]')
              );
            }
            return false;
          });
        });

        if (hasRelevantChanges) {
          clearTimeout(this.mutationDebounceTimer);
          this.mutationDebounceTimer = setTimeout(() => {
            console.log('B2B Pricing: Neue Produkte erkannt (MutationObserver), berechne Preise...');
            this.calculateCollectionPrices();
          }, 300);
        }

        // Also check for price element changes (variant updates via section rendering)
        const hasPriceChanges = mutations.some(mutation => {
          return Array.from(mutation.addedNodes).some(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const hasPriceEl = node.matches && node.matches('[data-product-id]') ||
                                 (node.querySelector && node.querySelector('[data-product-id]'));
              if (hasPriceEl) {
                console.log('B2B Pricing: Price element changed (MutationObserver)', node);
              }
              return hasPriceEl;
            }
            return false;
          });
        });

        if (hasPriceChanges) {
          clearTimeout(this.mutationDebounceTimer);
          this.mutationDebounceTimer = setTimeout(() => {
            console.log('B2B Pricing: Price element updated, recalculating...');
            this.calculateProductPrice();
          }, 100);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      console.log('B2B Pricing: MutationObserver mit Debouncing aktiviert');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.B2BPriceCalculatorInstance = new B2BPriceCalculator();
    });
  } else {
    window.B2BPriceCalculatorInstance = new B2BPriceCalculator();
  }

  console.log('B2B Pricing: Script geladen und bereit');
})();